import type { IconData } from '@stacksjs/iconify-core'

export const exclamationOctagon: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M15.728 22H8.272a1 1 0 0 1-.707-.293l-5.272-5.272A1 1 0 0 1 2 15.728V8.272a1 1 0 0 1 .293-.707l5.272-5.272A1 1 0 0 1 8.272 2h7.456a1 1 0 0 1 .707.293l5.272 5.272a1 1 0 0 1 .293.707v7.456a1 1 0 0 1-.293.707l-5.272 5.272a1 1 0 0 1-.707.293\" opacity=\".5\"/><circle cx=\"12\" cy=\"16\" r=\"1\" fill=\"currentColor\"/><path fill=\"currentColor\" d=\"M12 13a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default exclamationOctagon
